import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ChatService } from '../chat.service';
import { InputDirective } from "../../input/input.directive";
import { PreloaderService } from "../../service/preloader.service";
import { DASHBOARD_STEPS } from "../../config/project";
import { AuthenticationService } from 'src/app/auth/_services/authentication.service';

@Component({
  selector: 'app-guest-user',
  templateUrl: './guest-user.component.html',
  styleUrls: ['./guest-user.component.scss']
})
export class GuestUserComponent implements OnInit {
  @ViewChild(InputDirective, { static: false }) input: InputDirective;
  @Output() popUpClosed = new EventEmitter();

  backLink = "/blocks";
  infoText = DASHBOARD_STEPS[8].text;

  guest: {
    firstName: string,
    lastName: string,
    phoneNumber: number,
    email: string,
    unfavorableDate: string,
    representedHearing: string,
    contactingInfo: string,
    summary: string,
    type: number
  } = {
      firstName: '',
      lastName: '',
      phoneNumber: null,
      email: '',
      unfavorableDate: null,
      representedHearing: null,
      contactingInfo: null,
      summary: '',
      type: 0
    };

  popupShow = false;
  popupSuccess = false;
  popupMessage = '';

  selectOtherIssueQuestion = {
    "answerLength": 900,
    "fieldTitle": "Type other Issue in max 900 characters",
    "fieldType": "textarea",
    "questionId": 96,
    "questionTitle": "title"
  };

  constructor(private chatService: ChatService,
    private authenticationService: AuthenticationService,
    private preloaderService: PreloaderService) {
  }

  ngOnInit() {
    // this.getGuestInfo();
  }

  getGuestInfo() {
    this.chatService.getProfileInfo().subscribe(data => {

      console.log('avatar', data);

      this.preloaderService.hide();

      if (data.status) {
        this.guest = {
          firstName: data.result.first_name,
          lastName: data.result.last_name,
          phoneNumber: data.result.phone,
          email: data.result.email,
          unfavorableDate: data.result.unfavorable_date,
          representedHearing: data.result.represented_hearing,
          contactingInfo: data.result.contacting_info,
          summary: data.result.summary,
          type: 0
        };
      }
    });
  }

  handleGuestSave() {
    this.preloaderService.show();
    this.popupShow = false;

    this.chatService.setGuestInfo(this.guest).subscribe((res: any) => {
      const guest = {firstName: this.guest.firstName, lastName: this.guest.lastName, phone: this.guest.phoneNumber, email: this.guest.email, type: 'Something Else'};
      this.authenticationService.alertPaperclip(guest);
      this.preloaderService.hide();
      if (res.status) {
        this.popupShow = true;
        this.popupSuccess = true;
      } else {
        this.popupShow = true;
        this.popupSuccess = false;
      }

      this.popupMessage = res.message;
    });
  }

  closePopup(){
    this.popUpClosed.emit();
  }

}

